import Journey from '@models/Journey'

export const getAllActiveJourneysIds = () => {
  return Journey.query()
    .withAllRecursive()
    .where((journey) => journey.active_journey_id !== '')
    .get()
    .map((journey) => journey.id)
}

export const getAllActiveJourneys = () => {
  return Journey.query()
    .withAllRecursive()
    .whereIdIn(getAllActiveJourneysIds())
    .get()
    .map((journey) => journey.journey_planner_response[0])
}
